import { Component, inject, input, model, output, signal } from '@angular/core';
import { BranchesService } from '../services/branches.service';
import { RoutesService } from '../../shared/services/routes.service';
import { BranchModel } from '../../shared/models/branch.model';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { AccessService } from '../../core/services/access.service';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { RippleModule } from 'primeng/ripple';
import { ResourceFormCardComponent } from "../../shared/components/resource-form-card/resource-form-card.component";

@Component({
  selector: 'app-branches-list',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TableModule,
    ButtonModule,
    ButtonGroupModule,
    RippleModule,
    ResourceFormCardComponent
],
  templateUrl: './branches-list.component.html',
  styleUrl: './branches-list.component.css'
})
export class BranchesListComponent {
  protected service = inject(BranchesService)
  protected routesService = inject(RoutesService)

  protected access = inject(AccessService).access
  protected resource = this.service.resource?.toLowerCase();

  public detailed = input<boolean>(true);

  protected value = this.service.branches

  public length = output<number>()

  ngOnInit(): void {
    // console.log('OnInit called of ListBranchComponent.')
    this.service.title.update((value) => 'Lista de Sucursales')
    this.service.get().subscribe(data => { this.value.update(value => {
      value = data as BranchModel[]
      // console.log('Branch List: ', value)
      // console.log('value ad List: ', value.length)
      this.length.emit(value.length)
      return value
    })})
  }
}
